import { m8API } from 'services/production/m8';
import { GetPartnerCancelledClientsTableItemsService } from 'types/services';
import { normalizeM8PartnerCancelledClientDTO } from '../utils/normalizeM8PartnerCancelledClientDTO';

export const getPartnerCancelledClientsTableItems: GetPartnerCancelledClientsTableItemsService = async () => {
  const m8PartnerClients = await m8API.partner.getCancelledClients();

  return m8PartnerClients.clients.map((m8PartnerCancelledClient) =>
    normalizeM8PartnerCancelledClientDTO(
      m8PartnerCancelledClient
    ).toPartnerClientsTableItem()
  );
};
